import { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { api } from '@/lib/api';

export default function EliminarCuentaConfirmar() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: 'loading', message: '' });
  const once = useRef(false);

  useEffect(() => {
    if (once.current) return;
    once.current = true;
    const token = params.get('token');
    if (!token) { setState({ status: 'error', message: 'Enlace incompleto.' }); return; }
    api.post('/account-deletion/confirm', { token })
      .then(({ data }) => setState({ status: 'ok', message: data.message }))
      .catch((e) => setState({ status: 'error', message: e.response?.data?.detail || 'No pudimos confirmar la solicitud.' }));
  }, [params]);

  const tone = state.status === 'ok' ? 'border-emerald-200 bg-emerald-50 text-emerald-900'
    : state.status === 'error' ? 'border-red-200 bg-red-50 text-red-900' : 'border-slate-200 bg-white text-slate-700';
  return (
    <Layout>
      <div className="mx-auto max-w-xl px-4 py-16" data-testid="delete-confirm-page">
        <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-orange-600">AutoMarket Colombia</div>
        <h1 className="mt-2 font-display font-bold text-3xl text-slate-900">Confirmar eliminación de cuenta</h1>
        <div className={`mt-6 border p-5 text-sm ${tone}`} data-testid={`delete-confirm-${state.status}`}>
          {state.status === 'loading' ? 'Verificando enlace…' : state.message}
        </div>
        <Link to="/eliminar-cuenta" className="mt-4 inline-block text-sm underline" data-testid="delete-confirm-back-link">
          Volver a Eliminar mi cuenta
        </Link>
      </div>
    </Layout>
  );
}
